import { EventEmitter, Injectable } from '@angular/core';
import { Observable, of, Subject, Subscriber } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { HaloModalOptions } from './halo-modal-interface';

@Injectable({
  providedIn: 'root',
})
export class HaloModalService {
  private option: HaloModalOptions[] = [];
  private active: boolean = false;

  private _firstOption = new Subject<HaloModalOptions | undefined | null>();
  public firstOptionSource = this._firstOption.asObservable();

  constructor() {
    this._firstOption.next(null);
  }

  add(option: HaloModalOptions) {
    this.option.push(option);
    this.publish(false);
  }

  addForeground(option: HaloModalOptions) {
    this.option.unshift(option);
    this.show();
  }

  private publish(isOnDismissed: boolean) {
    if (this.option.length > 0 && !this.active) {
      this.show();
    } else {
      if (isOnDismissed) {
        this._firstOption.next(null);
      }
    }
  }

  onDismissed() {
    this.active = false;
    this.option.splice(0, 1);
    this.publish(true);
  }

  close() {
    this.onDismissed();
  }

  private show() {
    this.active = true;
    this._firstOption.next(this.option[0]);
  }
}
